import React, { useEffect, useState, useCallback } from 'react';
import { Switch } from 'react-router-dom';
import { observer } from 'mobx-react';

import { routesSchema, PublicRoute, PrivateRoute } from '../../core/navigation';
import { useMst } from '../../core/stores/RootStore';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

export const Root: React.FC = observer(() => {
  const { configStore } = useMst();
  const routes = routesSchema;
  const [translations, setTranslations] = useState({});
  const [alertOpen, setAlertOpen] = useState(true);

  const initialFetch = useCallback(async () => {
    const result = await configStore.getTranslations('en');
    setTranslations(result);
  }, [configStore, setTranslations]);

  useEffect(() => {
    initialFetch();
  }, [initialFetch]);

  const handleClose = () => {
    setAlertOpen(false);
  };

  return (
    <>
      {translations && translations['BANNER_ALERT'] && (
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={alertOpen}
          onClose={handleClose}
        >
          <Alert
            elevation={6}
            variant="filled"
            severity="warning"
            onClose={handleClose}
            color={'error'}
          >
            {translations['BANNER_ALERT']}
          </Alert>
        </Snackbar>
      )}
      <Switch>
        {routes.map(route => {
          return route.private ? (
            <PrivateRoute key={route.name} {...route} />
          ) : (
            <PublicRoute key={route.name} {...route} />
          );
        })}
      </Switch>
    </>
  );
});

export default Root;
